// local
import { baseFetch } from '../../baseFetch';
import {
  GetSolarFarmByUuidResponseSchema,
  SolarFarmSearchResponseSchema,
} from './solar-farm.schema';

export const getSolarFarmsByName = (
  name: string,
  { signal }: { signal: AbortSignal | undefined },
) => {
  return baseFetch(
    'internal-v2',
    '/solar_farms',
    SolarFarmSearchResponseSchema,
    {
      searchParams: {
        name,
      },
      abortSignal: signal,
    },
  );
};

export const getSolarFarmByUuid = (solar_farm_uuid: string) => {
  return baseFetch(
    'internal-v2',
    `/solar_farms/${solar_farm_uuid}`,
    GetSolarFarmByUuidResponseSchema,
  );
};
